var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isClient)?_c('live2d',{ref:"live2d",style:(_vm.style),attrs:{"apiPath":"/live2d-static-api/indexes","model":['bilibili-live/22', 'default'],"direction":_vm.direction,"size":_vm.size,"home-page":"https://fengling.work","tips":_vm.tips}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }